import './bootstrap'; //Laravel bootstrap.
import './assets/sass/app.scss';
import './assets/sass/global.scss';

import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import Vuex from "vuex";
import BootstrapVue from "bootstrap-vue";
import VeeValidate from "vee-validate";
import VueSweetalert2 from "vue-sweetalert2";
import VueCodemirror from "vue-codemirror";
import VChart from "v-chart-plugin/src/v-chart-plugin.js";
import Chart from "./chart-wrapper";
import ChartDraw from "./chart-wrapper-draw";
import Clipboard from "v-clipboard";
import fullscreen from "vue-fullscreen";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faTerminal,
  faDatabase,
  faChartPie,
  faFileAlt,
  faPlus,
  faEdit,
  faTrashAlt,
  faEye,
  faPlusCircle,
  faSave,
  faPlay,
  faArrowLeft,
  faTable,
  faChartBar,
  faChartLine,
  faChartArea,
  faEllipsisH,
  faUserCircle,
  faBuilding,
  faSignOutAlt,
  faCog,
  faSearch,
  faPencilAlt,
  faCheckCircle,
  faTimesCircle,
  faSortNumericDown,
  faSyncAlt,
  faAngleDown,
  faArrowAltCircleDown,
  faUsers,
  faLayerGroup,
  faCompress,
  faExpand,
  faShareSquare,
  faInfo,
  faCode,
  faFileExport,
  faDownload
} from "@fortawesome/free-solid-svg-icons";
import { faAddress } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(
  faTerminal,
  faDatabase,
  faChartPie,
  faFileAlt,
  faPlus,
  faEdit,
  faTrashAlt,
  faEye,
  faSave,
  faPlusCircle,
  faPlay,
  faArrowLeft,
  faTable,
  faChartBar,
  faChartLine,
  faChartArea,
  faEllipsisH,
  faUserCircle,
  faBuilding,
  faSignOutAlt,
  faCog,
  faSearch,
  faPencilAlt,
  faCheckCircle,
  faTimesCircle,
  faSortNumericDown,
  faSyncAlt,
  faAngleDown,
  faArrowAltCircleDown,
  faUsers,
  faDownload,
  faLayerGroup,
  faCompress,
  faExpand,
  faShareSquare,
  faInfo,
  faCode,
  faFileExport
);
Vue.component("font-awesome-icon", FontAwesomeIcon);
import VueAnalytics from "vue-analytics";

import App from "./App.vue";
import router from "./router";
import store from "./store/store";
import 'ag-grid-enterprise';
import {LicenseManager} from "ag-grid-enterprise";

LicenseManager.setLicenseKey("Evaluation_License-_Not_For_Production_Valid_Until_1_July_2019__MTU2MTkzNTYwMDAwMA==8ea846c82b3280fc8df9f911fc6de1b9");

window.Vue = require("vue");

Vue.use(VueAnalytics, {
  id: "UA-134737826-2"
});

Vue.use(Vuex);
Vue.use(BootstrapVue);
Vue.use(VueAxios, axios);
Vue.use(VueCodemirror);
Vue.use(VueSweetalert2);
Vue.use(VeeValidate, { inject: false });
Vue.config.productionTip = false;
Vue.use(VChart);
Vue.use(Chart);
Vue.use(ChartDraw);
Vue.use(Clipboard);
Vue.use(fullscreen);

Vue.router = router;

Vue.use(require("@websanova/vue-auth"), {
  auth: require("@websanova/vue-auth/drivers/auth/bearer.js"),
  http: require("@websanova/vue-auth/drivers/http/axios.1.x.js"),
  router: require("@websanova/vue-auth/drivers/router/vue-router.2.x.js"),
  refreshData: { url: "/refresh", method: "POST", enabled: true, interval: 30 },
  fetchData: { url: "/auth/user", method: "GET", enabled: false }
});

Vue.$ga.page("/");

router.afterEach((to, from) => {
  Vue.$ga.page(to.path);
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title;
  next();
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");